import * as React from 'react';
import { tokens, Avatar } from '@fluentui/react-components';
import { useTranslation } from 'react-i18next';
import { StakeholderInformation } from '../hooks/client/types/CreateEmailObjectRequest';
import { ArrowLookup } from './icons';
import { CustomCardProps, CustomCard } from './CustomCard';
import { Button } from './Button';

type StakeholderCardProps = Omit<CustomCardProps, 'header' | 'caption' | 'icon'> & {
  stakeholder: StakeholderInformation;
  actions?: React.ReactNode;
};

export const StakeholderCard = ({ stakeholder, actions, ...rest }: StakeholderCardProps) => {
  const { t } = useTranslation();

  const { name, email, id: stakeholderId } = stakeholder;

  const stakeholderName = name || t('STAKEHOLDER_SELECTOR.UNKNOWN');

  const customActions = (
    <>
      {stakeholder.cmUrl && (
        <Button
          appearance="transparent"
          icon={<ArrowLookup color={tokens.colorNeutralForeground3} />}
          as="a"
          target="_blank"
          rel="noreferrer"
          href={stakeholder.cmUrl}
        />
      )}
      {actions}
    </>
  );

  return (
    <CustomCard
      header={stakeholderName}
      caption={email}
      icon={
        <Avatar
          name={name}
          color={stakeholderId ? 'colorful' : 'blue'}
          idForColor={`${stakeholderId}`}
        />
      }
      actions={customActions}
      {...rest}
    />
  );
};
